import TexturingConfigForm from './TexturingConfigForm'
import PropTypes from 'prop-types'

const ExpandedRow = (props) => (
  <TexturingConfigForm
    record={props.record}
    setStatus={props.setStatus}
    setCurrentFormValues={props.setCurrentFormValues}
    getRecordStatus={props.getRecordStatus}
    rowDataRef={props.rowDataRef}
  />
)

ExpandedRow.propTypes = {
  record: PropTypes.object.isRequired,
  setStatus: PropTypes.func.isRequired,
  setCurrentFormValues: PropTypes.func.isRequired,
  getRecordStatus: PropTypes.func.isRequired,
  rowDataRef: PropTypes.object.isRequired,
}

export default ExpandedRow
